import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

export function getElementWordCount(element) {
  if (!element) return null;
  if (!_isEmpty(_get(element, 'props.children'))) {
    if (typeof element.props.children === 'string')
      return element.props.children.split(' ').length;
    if (Array.isArray(element.props.children))
      return element.props.children.reduce((accumulator, child) => {
        if (child.type === 'span' && typeof child.props.children === 'string') {
          return accumulator + child.props.children.split(' ').length;
        }
        if (typeof child === 'string') {
          return accumulator + 1;
        }

        return accumulator + getElementWordCount(child.props.children);
      }, 0);
  }

  return 0;
}

export function getElementTextLength(element) {
  if (!element) return null;
  if (!_isEmpty(_get(element, 'props.children'))) {
    if (typeof element.props.children === 'string')
      return element.props.children.length;
    if (Array.isArray(element.props.children))
      return element.props.children.reduce((accumulator, child) => {
        if (child.type === 'span' && typeof child.props.children === 'string') {
          return accumulator + child.props.children.length;
        }
        if (typeof child === 'string') {
          return accumulator + 1;
        }

        return accumulator + getElementTextLength(child.props.children);
      }, 0);
  }

  return 0;
}

export function getPartialElement(element, len, readMore, color, hideReadText) {
  if (!element) return null;
  if (!_isEmpty(_get(element, 'props.children'))) {
    if (typeof element.props.children === 'string') {
      return (
        <>
          <span>{element.props.children.substring(0, len)}...</span>
          {!hideReadText && (
            <span
              role="button"
              onClick={readMore}
              onKeyDown={readMore}
              tabIndex={0}
              style={{
                cursor: 'pointer',
                color: color || '#01619B',
              }}
            >
              &nbsp;Read More
            </span>
          )}
        </>
      );
    }
    if (Array.isArray(element.props.children)) {
      let l = 0;
      for (let i = 0; i < element.props.children.length; i += 1) {
        const elementLength = getElementTextLength(element.props.children[i]);
        if (l + elementLength > len) {
          const res = element.props.children.slice(0, i);
          const partial = getPartialElement(
            element.props.children[i],
            len - l,
            readMore,
            color,
            hideReadText,
          );
          res.push(partial);
          return <p>{res}</p>;
        }
        l += elementLength;
      }
    }
  }

  return element;
}
